import type { ReactNode } from 'react';

export const symbol_float_landscape_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M560-410h170q12.75 0 21.38-8.63Q760-427.25 760-440v-210q0-12.75-8.62-21.38Q742.75-680 730-680H560q-12.75 0-21.37 8.62Q530-662.75 530-650v210q0 12.75 8.63 21.37Q547.25-410 560-410ZM140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm0 0v-520 520Z"
		/>
	</svg>
);
